import {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import Layout, {Caricamento, Titolo, Vuoto} from '../Layout';
import {Avvisi, Errore, gestisciErrore, getClienti, nominativo, soloData} from '../woo';

// Clienti registrati sul sito. L'elenco completo puo' essere lungo (il sito restituisce
// tutte le pagine), quindi si parte da una ricerca: vuota = tutti i clienti.
export default function ClientiPage() {
    const [params, setParams] = useSearchParams();
    const cerca = params.get('q');
    const [testo, setTesto] = useState(cerca ?? '');
    const [risultato, setRisultato] = useState(null);
    const [errore, setErrore] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (cerca === null) return; // nessuna ricerca lanciata
        setRisultato(null);
        setErrore('');
        const filtri = cerca.includes('@') ? {email: cerca.trim()} : {search: cerca.trim()};
        getClienti(filtri).then(setRisultato).catch(gestisciErrore(setErrore));
    }, [cerca]);

    function invia(event) {
        event.preventDefault();
        setParams({q: testo});
    }

    const clienti = risultato?.clienti ?? [];

    return (
        <Layout>
            <Titolo>Clienti e-commerce</Titolo>
            <div className="card mb-3">
                <div className="card-body">
                    <form className="row g-3 align-items-end" onSubmit={invia}>
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="q">Nome, email o username</label>
                            <input id="q" type="search" className="form-control" value={testo} placeholder="es. rossi"
                                   onChange={(e) => setTesto(e.target.value)}/>
                        </div>
                        <div className="col-auto">
                            <button type="submit" className="btn btn-primary">
                                <i className="bi-search me-2"></i>Cerca
                            </button>
                        </div>
                        <div className="col-12 text-secondary small">
                            Con un'email viene cercata la corrispondenza esatta; vuoto elenca tutti i clienti registrati.
                            Gli ordini fatti da ospiti non hanno un cliente: i dati sono nell'ordine.
                        </div>
                    </form>
                </div>
            </div>

            <Errore messaggio={errore}/>
            <Avvisi avvisi={risultato?.avvisi}/>
            {cerca !== null && (
                <div className="card">
                    <div className="card-body">
                        {!errore && risultato === null && <Caricamento/>}
                        {risultato && clienti.length === 0 && <Vuoto>Nessun cliente trovato.</Vuoto>}
                        {clienti.length > 0 && (
                            <>
                                <p className="text-secondary small mb-2">{risultato.totale} clienti</p>
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0">
                                        <thead>
                                        <tr>
                                            <th>Cliente</th>
                                            <th>Email</th>
                                            <th>Fatturazione</th>
                                            <th>Città</th>
                                            <th>Registrato</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {clienti.map((c) => (
                                            <tr key={c.id} className="riga-cliccabile" onClick={() => navigate(`/clienti/${c.id}`)}>
                                                <td className="fw-semibold">{[c.first_name, c.last_name].filter(Boolean).join(' ') || c.username}</td>
                                                <td>{c.email}</td>
                                                <td>{nominativo(c.billing)}</td>
                                                <td>{c.billing?.city}</td>
                                                <td className="text-nowrap">{soloData(c.date_created)}</td>
                                                <td className="text-end"><i className="bi-chevron-right text-secondary"></i></td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </Layout>
    );
}
